// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__WzvUP","name":"ConsentHeader_name__17pr5","birthday":"ConsentHeader_birthday__5IrVk","skeleton":"ConsentHeader_skeleton__2jhtc"};